import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { useCallback, useEffect } from "react";
import { FolderTreeDragHelper, useJqueryFolderTreeDraggable } from "@devowl-wp/react-folder-tree";
import { useStores } from "../../store/rootStore.js";
import { __, _n } from "../../utils/i18n.js";
/**
 * Detect a single click on touch devices to trigger the click handler.
 * This must be done because jQuery Touch Punch does not support click and
 * draggable concurrently.
 */ function draggableTouchClick(e) {
    if (!$("body").hasClass("aiot-currently-dragging")) {
        // Check native click event
        if (e.target.click) {
            e.target.click();
        } else {
            $(e.target).trigger("click");
        }
    }
}
function usePostDraggable(disabled) {
    const { optionStore: { others: { tableCheckboxName } } } = useStores();
    const renderHelper = useCallback((count)=>/*#__PURE__*/ _jsx(FolderTreeDragHelper, {
            moveLabel: _n("Move", "Move %d items", count, [
                count
            ]),
            moveHint: __("Hold any key to assign to an additional category"),
            appendLabel: _n("Copy", "Copy %d items", count, [
                count
            ]),
            appendHint: __("Release key to move")
        }), []);
    const makeDraggable = useJqueryFolderTreeDraggable({
        $,
        target: "#wpbody-content .wp-list-table tbody tr:not(.no-items) > :not(th)",
        disabled,
        getDragCount: ()=>$(`input[name="${tableCheckboxName}"]:checked`).length || 1,
        renderHelper,
        onTouchEnd: draggableTouchClick
    });
    useEffect(()=>{
        makeDraggable();
    }, [
        makeDraggable
    ]);
    return makeDraggable;
}
export { usePostDraggable };
